import { wrapAsDerivedFromMeasurementsConfig as wrap } from 'Components/Worksheets/Core/Helpers/configHelpers';

const getDerivedFromMeasurementsConfig = (prefix: string) => ({
  [`${prefix}.Preparation.TotalSampleMass`]: wrap([
    `${prefix}.Preparation.TareMass`,
    `${prefix}.Preparation.TareAndTotalSampleMass`,
  ]),
});

export default getDerivedFromMeasurementsConfig;
